import React from 'react';
import { useTranslation } from 'react-i18next';

import { Typography, styled } from 'netline-ui';

import styles, { licenseFooterClasses } from './LicenseFooter.styles';

const LicenseFooterRoot = styled('div', { name: licenseFooterClasses.$name })(styles);

const currentYear = new Date().getFullYear();

const LicenseFooter = ({ licenseUrl }: { licenseUrl?: string }) => {
  const { t } = useTranslation();

  return (
    <LicenseFooterRoot className={licenseFooterClasses.root} data-testid="LicenseFooter-root">
      <img
        src="./logo/LufthansaSystemsLogo.svg"
        alt="Lufthansa Systems Logo"
        title="Lufthansa Systems Logo"
        className={licenseFooterClasses.lsyLogo}
      />
      <Typography className={licenseFooterClasses.copyright}>
        {t('about.copyright_line', { year: currentYear })}
        {licenseUrl && (
          <Typography component="a" href="#" target="_blank" className={licenseFooterClasses.copyright}>
            {t('about.license_agreement')}
          </Typography>
        )}
      </Typography>
    </LicenseFooterRoot>
  );
};

export default LicenseFooter;
